var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBluesky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bluesky_Logo 1",
    clipPath: "url(#clip0_412_554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.33364 2.86215C9.43679 5.21436 12.7746 9.98368 14 12.5432C15.2256 9.98387 18.5632 5.21432 21.6664 2.86215C23.9055 1.16488 27.5334 -0.14837 27.5334 4.03046C27.5334 4.86502 27.0595 11.0413 26.7815 12.044C25.8154 15.53 22.2948 16.4191 19.1632 15.881C24.6372 16.8217 26.0297 19.9375 23.0224 23.0534C17.3109 28.9711 14.8133 21.5686 14.173 19.6719C14.0557 19.3242 14.0008 19.1615 14 19.2998C13.9992 19.1615 13.9443 19.3242 13.8269 19.6719C13.187 21.5686 10.6894 28.9712 4.97754 23.0534C1.97015 19.9375 3.36264 16.8215 8.83673 15.881C5.70503 16.4191 2.1844 15.53 1.2184 12.044C0.940443 11.0412 0.466553 4.86493 0.466553 4.03046C0.466553 -0.14837 4.09451 1.16488 6.33349 2.86215H6.33364Z",
    fill: "#1185FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24.973,
    fill: "white",
    transform: "translate(0 0.787598)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBluesky);
export default __webpack_public_path__ + "static/media/ic_bluesky.c43554d76d8e17dc11b4c7752b040fdb.svg";
export { ForwardRef as ReactComponent };